type Point = { top: number; left: number };
type Rule = {
  min: number;
  max: number;
  win:
    | { topOffset: number; leftOffset: number }
    | { top: number; left: number };
  mac:
    | { topOffset: number; leftOffset: number }
    | { top: number; left: number };
};

export function computeTooltipPosition(
  inputRect: DOMRect,
  textBeforeWidth: number,
  scrollX: number,
  scrollY: number,
  screenWidth: number,
  isWindows: boolean
): Point {
  const rules: Rule[] = [
    // mobile
    {
      min: 0,
      max: 768,
      win: { top: 80, left: 151 },
      mac: { top: 80, left: 151 },
    },
    // tablet / small laptop
    {
      min: 768,
      max: 1260,
      win: { topOffset: -205, leftOffset: -60 },
      mac: { topOffset: -205, leftOffset: 5 },
    },
    // 1260–1500
    {
      min: 1260,
      max: 1500,
      win: { topOffset: -210, leftOffset: -200 },
      mac: { topOffset: -210, leftOffset: -160 },
    },
    // 1500–1800
    {
      min: 1500,
      max: 1800,
      win: { topOffset: -210, leftOffset: -200 },
      mac: { topOffset: -210, leftOffset: -285 },
    },
    // 1800–2000
    {
      min: 1800,
      max: 2000,
      win: { topOffset: -210, leftOffset: -200 },
      mac: { topOffset: -210, leftOffset: -365 },
    },
    // 2000–2260
    {
      min: 2000,
      max: 2260,
      win: { topOffset: -210, leftOffset: -200 },
      mac: { topOffset: -210, leftOffset: -485 },
    },
    // ≥2260
    {
      min: 2260,
      max: Infinity,
      win: { topOffset: -210, leftOffset: -200 },
      mac: { topOffset: -210, leftOffset: -590 },
    },
  ];

  const rule = rules.find((r) => screenWidth >= r.min && screenWidth < r.max)!;
  const branch = isWindows ? rule.win : rule.mac;

  // if the branch gave literal coords, use them directly:
  if ("top" in branch && "left" in branch) {
    return { top: branch.top, left: branch.left };
  }

  // otherwise it's offsets relative to inputRect + scroll + text width
  return {
    top: inputRect.top + scrollY + branch.topOffset,
    left: inputRect.left + scrollX + textBeforeWidth + branch.leftOffset,
  };
}
